<div class="ui-dialog-content">
  <div class="ui-g">
    <div class="ui-g-12 ui-md-6">
      <p>{{ 'customerSetBuilder.selectSet' | translate }}</p>
      <p-dropdown [options]="queryList" [(ngModel)]="selectedQueryId" [style]="{'width':'100%'}">
        <ng-template let-query pTemplate="item">
          <div class="query-item">{{query.label}}<span class="fa fa-trash" (click)="deleteQuery(query.value.id, query.label)"></span></div>
      </ng-template>
      </p-dropdown>
    </div>
  </div>
</div>
<div class="ui-dialog-footer">
  <button
    type="button"
    pButton
    class="ui-button-success btnDelete"
    icon="fa fa-arrow-circle-o-down "
    (click)="selectQuery()"
    label="{{ 'customerSetBuilder.loadSet' | translate }}"
    [disabled]="!selectedQueryId">
  </button>
  <button
    type="button"
    pButton
    class="ui-button-danger btnDelete"
    icon="fa fa-close"
    (click)="onCloseDialog.emit()"
    label="{{ 'common.cancel' | translate }}">
  </button>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-builder/customer-set-load/customer-set-load.component.html